import FbWigdet from './modules/FbWidget';
import Form from './modules/Form';

class Index {
  constructor() {
    let menuEl = document.querySelector('nav .menu.list');

    require.ensure([
          './modules/headline',
          './modules/Benefits'
      ], (require)=> {
      require('./modules/headline');
      require('./modules/Benefits');
    });

    new FbWigdet({
        el: document.querySelector('.fb_widget'),
        fbid: '143193686287141',
        atoken: '1734363436858709|Q938KdXFiWglFr6bUlgIQ4dHVDo'
    });

    if (menuEl) {
      require.ensure([
            './modules/RespMenu'
        ], (require)=> {
        const Menu = require('./modules/RespMenu').default;
        new Menu(menuEl);
      });
    }

    new Form();
  }
}


window.addEventListener('load', new Index());



// WEBPACK FOOTER //
// ./index.js